import { BaseEffect, EasingFunction, Easing, CanvasDimensions, EffectResult } from './BaseEffect';

/**
 * ZoomEffect animates the zoom level of the video.
 * @param from - Starting zoom (1 = 100%, or 100 if isPercent=true)
 * @param to - Ending zoom (1 = 100%, or 100 if isPercent=true)
 * @param duration - Duration in seconds
 * @param at - Start time in seconds
 * @param easing - Easing function
 * @param isPercent - If true, from/to are percentages (e.g., 100 for 100%)
 */
export class ZoomEffect extends BaseEffect {
    from: number; // normalized zoom value (1 = 100%)
    to: number;   // normalized zoom value (1 = 100%)

    constructor(
        from: number, 
        to: number, 
        duration: number, 
        at?: number,
        easing: EasingFunction = Easing.easeOutCubic,
        isPercent: boolean = false
    ) {
        super('zoom', duration, at, easing);
        this.from = isPercent ? from / 100 : from;
        this.to = isPercent ? to / 100 : to;
    }

    apply(
        ctx: CanvasRenderingContext2D,
        dimensions: CanvasDimensions,
        progress: number,
        prev: EffectResult
    ): EffectResult {
        const currentZoom = this.from + (this.to - this.from) * progress;
        
        // Calculate center point using resolution dimensions
        const centerX = dimensions.resolutionWidth / 2;
        const centerY = dimensions.resolutionHeight / 2;
        
        // Apply zoom transformation relative to current state
        ctx.translate(centerX, centerY);
        ctx.scale(currentZoom, currentZoom);
        ctx.translate(-centerX, -centerY);
        return prev;
    }
} 